/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Profiles Management View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './profilesManagementView';

export const mapStateToPropsProfileManagement = mapStateToProps;
export const mapDispatchToPropsProfileManagement = mapDispatchToProps;

export default connect(
  mapStateToPropsProfileManagement,
  mapDispatchToPropsProfileManagement
)(View);
